import { visit as f, SKIP as g } from "unist-util-visit";
import { u as p } from "unist-builder";
import { getBaseUrl as u, getRootUrl as a } from "@nextcloud/router";
const b = /(\s|^)(https?:\/\/)([-A-Z0-9+_.]+(?::[0-9]+)?(?:\/[-A-Z0-9+&@#%?=~_|!:,.;()]*)*)(\s|$)/ig, c = /(\s|\(|^)((https?:\/\/)([-A-Z0-9+_.]+[-A-Z0-9]+(?::[0-9]+)?(?:\/[-A-Z0-9+&@#%?=~_|!:,.;()]*)*))(?=\s|\)|$)/ig;
/**
 * @copyright Copyright (c) 2022 Julius Härtl <jus@bitgrid.net>
 *
 * @author Julius Härtl <jus@bitgrid.net>
 * @author Raimund Schlüßler <raimund.schluessler@mailbox.org>
 * @author Maksim Sukharev <antreesy.web@gmail.com>
 * @author Grigorii K. Shartsev <me@shgk.me>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const d = {
  name: "NcLink",
  props: {
    href: {
      type: String,
      required: !0
    }
  },
  render(r) {
    return r("a", {
      attrs: {
        href: this.href,
        rel: "noopener noreferrer",
        target: "_blank",
        class: "rich-text--external-link"
      }
    }, [this.href.trim()]);
  }
}, k = function({ autolink: r, useMarkdown: e, useExtendedMarkdown: s }) {
  return function(h) {
    s || !e || !r || f(h, (o) => o.type === "text", (o, t, l) => {
      let i = m(o.value);
      return i = i.map((n) => typeof n == "string" ? p("text", n) : p("link", {
        url: n.props.href
      }, [p("text", n.props.href)])).filter((n) => n), l.children.splice(t, 1, ...i.flat()), [g, t + i.flat().length];
    });
  };
}, m = (r) => {
  let e = c.exec(r);
  const s = [];
  let h = 0;
  for (; e !== null; ) {
    let t = e[2], l, i = r.substring(h, e.index + e[1].length);
    t[0] === " " && (i += t[0], t = t.substring(1).trim());
    const n = t[t.length - 1];
    (n === "." || n === "," || n === ";" || e[0][0] === "(" && n === ")") && (t = t.substring(0, t.length - 1), l = n), s.push(i), s.push({ component: d, props: { href: t } }), l && s.push(l), h = e.index + e[0].length, e = c.exec(r);
  }
  s.push(r.substring(h));
  const o = s.map((t) => typeof t == "string" ? t : t.props.href).join("");
  return r === o ? s : (console.error("Failed to reassemble the chunked text: " + r), r);
}, R = (r, e) => {
  if (!r)
    return null;
  const s = /^https?:\/\//.test(e);
  if (s && !e.startsWith(u()) || !s && !e.startsWith(a()))
    return null;
  const h = r.history.base, o = s ? e.slice(new URL(e).origin.length) : e, t = e.startsWith((s ? u() : a()) + "/index.php") ? o.replace("/index.php", "") : o, l = h.replace("/index.php", "");
  if (!t.startsWith(l))
    return null;
  const i = t.replace(l, "") || "/", n = r.resolve(i).route;
  return n.matched.length ? n.fullPath : null;
};
export {
  b as U,
  R as g,
  m as p,
  k as r
};
